/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

! function() {
    "use strict";

    angular.module('webReader').service('BookmarksModel', constructor);

    function constructor(NetworkService, DocumentModel, DocumentService, BookmarksService,$rootScope) {
        var self = this;
        var bookmarksCollection = [];
        var docPath = '';
        var onBookmarksUpdate = [];
        var onBookmarkLoaded = {};
        $rootScope.bookmarkOffset = []
        var chaptersPromises = {};


        angular.extend(self, {
            subscribe: {
                onBookmarksUpdate: function(callbackFunction) {
                    onBookmarksUpdate.push(callbackFunction);
                },
                onBookmarkLoaded: function(bookmarkIndex, callBackFunction) {
                    if (_.isUndefined(onBookmarkLoaded[bookmarkIndex])) {
                        onBookmarkLoaded[bookmarkIndex] = [];
                    }

                    onBookmarkLoaded[bookmarkIndex].push(callBackFunction);
                    return onBookmarkLoaded[bookmarkIndex].length - 1;
                }
            },
            unsubscribe: {
                onBookmarkLoaded: function(bookmarkIndex, callbackId) {
                    if (!_.isNull(onBookmarkLoaded[bookmarkIndex]) &&
                        !_.isNull(onBookmarkLoaded[bookmarkIndex][callbackId])) {
                        onBookmarkLoaded[bookmarkIndex][callbackId] = null;
                    }
                },
            },

            executeSubscriptions: function(callbacks, args) {
                var self = this;
                return _.every(callbacks, function(fn) {
                    if (!_.isNull(fn)) {
                        return fn.apply(self, [args]) !== false;
                    }
                })
            },

            checkIf: {
                isBookmarkLoaded: function(bookmarkIndex) {
                    return !!bookmarksCollection[bookmarkIndex] && bookmarksCollection[bookmarkIndex].status === 'LOADED';
                }
            },

            create: function() {
                DocumentModel.subscribe.onModelUpdate(function() {
                    NetworkService.getBookmarks(DocumentModel.getDocumentPath()).then(self.invoke);
                });
            },
            invoke: function(data) {
                bookmarksCollection = _.filter(data, function(el) {
                    //filter only bookmarks
                    return !!el.type && el.type === 'bookmark';
                });

                _.map(bookmarksCollection, function(el, i) {
                    el.index = i;
                    // console.log(i)
                    NetworkService.getBookmark(DocumentModel.getDocumentPath(), el.uuid).then(self.updateBookmark(i));
                });
                self.executeSubscriptions.call(this, onBookmarksUpdate, []);
            },
            updateBookmark: function(bookmarkIndex) {
                // console.log(arguments)
                var _bookmarkIndex = bookmarkIndex;
                bookmarksCollection[bookmarkIndex].status = 'LOADING';

                return function(data) {
                    bookmarksCollection[_bookmarkIndex] = data;
                    bookmarksCollection[_bookmarkIndex].status = 'LOADED';
                    
                    self.executeSubscriptions.call(this, onBookmarkLoaded[_bookmarkIndex], []);

                    //check if chapter is loaded, then load it or subscribe onchapterloaded
                    // console.log('bokmat', data);
                    data.position = {
                        start_pointer: DocumentService.parseCfiPosition(data.mark.anchor)
                    };
                    // console.log(DocumentService.parseCfiPosition(data.mark.anchor), 'anchi=or')
                    //  $rootScope.$emit('offsets', $rootScope.bookmarkOffset);
                    var chapterIndex = DocumentModel.getChapterIdByUrl(data.position.start_pointer.url);

                    if (DocumentModel.checkIf.isChapterRendered(chapterIndex)) {
                        data.bookmarkReferencedObject = DocumentService.getChapterOffsetObject(data.position.start_pointer.offsetChar, chapterIndex);
                        data.offsetTopTest = angular.element(data.bookmarkReferencedObject.element).position().top; 
                       var viewportOffset = data.offsetTopTest;
                       var page = Math.ceil(DocumentService.getTotalPagesCount() * (DocumentModel.getPreviousChaptersLength() +
                                (DocumentModel.getLoadedContentLength() *
                                    (viewportOffset / angular.element('content-wrapper').height()))) / DocumentModel.getTotalContentLength());
                        data.page = page;          
                         console.log(page, DocumentService.getTotalPagesCount())  
                        BookmarksService.createBookmark(data);
                        self.executeSubscriptions.call(this, onBookmarkLoaded[_bookmarkIndex], { bookmarkObject: data });
                        self.executeSubscriptions.call(this, onBookmarksUpdate, { bookmarkObject: data });
                    } else {
                        chaptersPromises[chapterIndex] = DocumentService.subscribe.onChapterRendered(chapterIndex, (function() {
                            var chapterPromise = chaptersPromises[chapterIndex];
                            var chapterId = chapterIndex;
                            var bookmarkObject = data;
                            return function() {
                                DocumentService.unsubscribe.onChapterRendered(chapterId, chapterPromise);
                                bookmarkObject.position = {
                                    start_pointer: DocumentService.parseCfiPosition(data.mark.anchor)
                                };
                                bookmarkObject.bookmarkReferencedObject = DocumentService.getChapterOffsetObject(bookmarkObject.position.start_pointer.offsetChar, chapterIndex);
                                bookmarkObject.offsetTopTest = angular.element(data.bookmarkReferencedObject.element).position().top; 
                                var viewportOffset = angular.element(data.bookmarkReferencedObject.element).position().top;
                                var page = Math.ceil(DocumentService.getTotalPagesCount() * (DocumentModel.getPreviousChaptersLength() +
                                (DocumentModel.getLoadedContentLength() *
                                    (viewportOffset / angular.element('content-wrapper').height()))) / DocumentModel.getTotalContentLength());
                                   bookmarkObject.page = page;  
                                 console.log(page);
                                BookmarksService.createBookmark(bookmarkObject);
                                self.executeSubscriptions.call(this, onBookmarkLoaded[_bookmarkIndex], { bookmarkObject: bookmarkObject });
                                self.executeSubscriptions.call(this, onBookmarksUpdate, { bookmarkObject: bookmarkObject });
                            };
                        })())
                    }
                }
            },

            getBookmarks: function() {
                return bookmarksCollection;
            },

            getBookmarkByUuid: function(uuid) {
                return _.filter(bookmarksCollection, function(el, i) {
                    return el.uuid === uuid;
                })
            },

            getBookmarkByIndex: function(bookmarkIndex) {
                return bookmarksCollection[bookmarkIndex];
            },

            addBookmark: function() {
                NetworkService.addBookmark(DocumentModel.getDocumentPath(), DocumentService.getCurrentChapterOffsetObject()).then(function(data) {
                    bookmarksCollection.push({
                        uuid: data.uuid
                    });
                    // console.log(bookmarksCollection);    
                    NetworkService.getBookmark(DocumentModel.getDocumentPath(), data.uuid).then(self.updateBookmark(bookmarksCollection.length - 1));
                    self.executeSubscriptions.call(this, onBookmarksUpdate, []);
                });
            },

            removeBookmark: function(uuid) {
                NetworkService.removeBookmark(DocumentModel.getDocumentPath(), uuid).then(function() {
                    for (var i = bookmarksCollection.length - 1; i >= 0 && bookmarksCollection[i].uuid !== uuid; i--) {};
                    if (i >= 0) {
                        bookmarksCollection.splice(i, 1);
                        BookmarksService.removeBookmark(uuid);
                    }
                    self.executeSubscriptions.call(this, onBookmarksUpdate, []);
                });
            }
        });
    }
    constructor.$inject = ["NetworkService", "DocumentModel", "DocumentService", "BookmarksService", "$rootScope"];
}();